<template>
  <div class="limit-manage-list">
    <el-breadcrumb separator=">" class="bc-nav noborder">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>融资管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>额度管理列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-wrap">
      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">融资产品名称</span>
        <el-input
          v-model.trim="tableOptions.financingProduct"
          :maxlength="30"
          clearable
          placeholder="请输入"
          style="width: 200px"
        ></el-input>
      </div>
      <div class="toolbar-item">
        <el-button type="primary" @click="handleSearch" id="auto-2">筛选</el-button>
        <el-button class="custom-reset-btn" @click="resetOption" id="auto-3">重置</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 额度管理列表 </span>
      </div>
    </div>
    <div class="table-custom-box" id="auto-4">
      <fe-table
        :tableData="tableData"
        :columns="columns"
        border
        :show-pagination="true"
        :pagination-config="pagination"
        @pagination-current-change="handleCurrentChange"
        @pagination-size-change="handleSizeChange"
      >
        <template #creditLimit="{ scope }">
          <span>{{ scope.row.creditLimit | thousands(2) }}</span>
        </template>
        <template #usedLimit="{ scope }">
          <span>{{ scope.row.usedLimit | thousands(2) }}</span>
        </template>
        <template #availableLimit="{ scope }">
          <span>{{ scope.row.availableLimit | thousands(2) }}</span>
        </template>
      </fe-table>
    </div>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:4
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import api from '@/api/base.new.api';
import tableMixin from '@/utils/tableMixin';
import { thousands } from '@fe/filter';
export default {
  name: 'limitManageList',
  mixins: [tableMixin],
  data() {
    return {
      columns: [
        { label: '额度编号', prop: 'limitNumber', 'min-width': 120 },
        { label: '融资产品名称', prop: 'financingProductName', 'min-width': 120 },
        { label: '资金渠道', prop: 'fundingChannel', 'min-width': 100 },
        { label: '额度状态', prop: 'limitStatus', 'min-width': 100 },

        { label: '授信额度(元)', prop: 'creditLimit', 'min-width': 110 },
        { label: '已用额度(元)', prop: 'usedLimit', 'min-width': 110 },
        { label: '可用额度(元)', prop: 'availableLimit', 'min-width': 110 },

        { label: '额度生效日', prop: 'effectiveDate', 'min-width': 120 },
        { label: '额度失效日', prop: 'expiryDate', 'min-width': 120 }
      ],
      tableOptions: {
        financingProduct: ''
      },
      axiosConfig: { url: api.financingApplyQueryFeePage }
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {}
};
</script>
